import { useReceiptService } from "serviceHooks";
import { FileHelper } from "utils/helpers";

function useReceiptDownload(receiptId: number) {
  const receiptService = useReceiptService();
  const onDownloadClick = () => {
    return receiptService.getPdf(receiptId).then((res) => {
      FileHelper.download(res);
    });
  };

  return onDownloadClick;
}

export default useReceiptDownload;
